// extracted by mini-css-extract-plugin
export var container = "block-title-desktop-module--container--_EnjD";
export var text = "block-title-desktop-module--text--M8lDW";
export var about = "block-title-desktop-module--about--2ifce";
export var ecotrans = "block-title-desktop-module--ecotrans--1pami";
export var waste = "block-title-desktop-module--waste--a9J3C";